import { render, staticRenderFns } from "./AddAbsences.vue?vue&type=template&id=29d49461&"
import script from "./AddAbsences.vue?vue&type=script&lang=ts&"
export * from "./AddAbsences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports